"use client";

import { useTranslations } from "next-intl";
import { virtualMarketing } from "../../../../public/images/three-sixty";
import StepContainer from "./StepContainer";

const StepFive = () => {
  const t = useTranslations("threeSixtySteps.steps");

  return (
    <div className="gs--page-column py-16">
      <StepContainer
        title={t("step5.title")}
        text={t("step5.text")}
        src={virtualMarketing}
        alt={"Beispielansicht eines Layouts von einer Webseite"}
        imageFit="cover"
        width={470}
      />
    </div>
  );
};

export default StepFive;
